import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloatingButton = () => {
    const handleClick = () => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const whatsappUrl = isMobile
            ? "https://wa.me/94741814164"
            : "https://web.whatsapp.com/send?phone=94741814164";

        window.open(whatsappUrl, "_blank");
    };

    return (
        <button
            onClick={handleClick}
            className="fixed bottom-4 right-4 z-50 bg-green-500 hover:bg-green-600 text-white p-3 md:p-4 rounded-full shadow-lg transition duration-300 ease-in-out"
        >
            <FaWhatsapp className="text-2xl md:text-3xl" />
        </button>
    );
};

export default WhatsAppFloatingButton;
